/**
 * Swiper settings for trader/review-slider, shared by the front end
 * (src/js/theme.js) and the editor preview (editor/index.js). Same values as
 * the old Reviews block slider; each block gets its own arrows and dots.
 *
 * @param {HTMLElement} slider The `.js-reviews-slider` element.
 * @return {Object} Swiper options.
 */
export default function reviewSliderOptions( slider ) {
	const block = slider.closest( '.reviews-slider' );

	return {
		loop: false,
		slidesPerView: 1,
		spaceBetween: 30,
		speed: 1000,
		navigation: {
			nextEl: block?.querySelector( '.swiper-button-next' ),
			prevEl: block?.querySelector( '.swiper-button-prev' ),
		},
		pagination: {
			el: slider.querySelector( '.swiper-pagination' ),
			clickable: true,
		},
		breakpoints: {
			768: { slidesPerView: 2, spaceBetween: 40 },
			992: { slidesPerView: 2.5, spaceBetween: 40 },
			1440: { slidesPerView: 3.58, spaceBetween: 40 },
			1921: { slidesPerView: 4.3, spaceBetween: 40 },
		},
	};
}
